import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "payment-progress"
};
var _hoisted_2 = {
  class: "d-flex fl-j-c fl-a-c payment-reference mb-20 mt-20"
};
var _hoisted_3 = {
  class: "d-flex fl-a-c prefix"
};
var _hoisted_4 = {
  class: "d-flex fl-j-c mt-20"
};

var _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "receipt"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "receipt-header freg mb-20"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "ftitle f-bold f-center"
}, "CARDHOLDER COPY")]), /*#__PURE__*/_createElementVNode("div", {
  class: "receipt-info"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "d-flex fl-jsb mb-10 freg"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "45%"
  }
}, "Date"), /*#__PURE__*/_createElementVNode("div", null, "27.12.2023")]), /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex fl-jsb mb-10 freg"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "45%"
  }
}, "Time"), /*#__PURE__*/_createElementVNode("div", null, "12:00:00")]), /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex fl-jsb mb-10 freg"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "45%"
  }
}, "Card"), /*#__PURE__*/_createElementVNode("div", null, "********")]), /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex fl-jsb mb-10 freg"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "45%"
  }
}, "PAN seq."), /*#__PURE__*/_createElementVNode("div", null, "**")]), /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex fl-jsb mb-10 freg"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "45%"
  }
}, "Pref.name"), /*#__PURE__*/_createElementVNode("div", null, "********")]), /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex fl-jsb mb-10 freg"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "45%"
  }
}, "Card type"), /*#__PURE__*/_createElementVNode("div", null, "***")]), /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex fl-jsb mb-10 freg"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "45%"
  }
}, "Payment method"), /*#__PURE__*/_createElementVNode("div", null, "********")]), /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex fl-jsb mb-10 freg"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "45%"
  }
}, "Payment variant"), /*#__PURE__*/_createElementVNode("div", null, "***")]), /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex fl-jsb mb-20 freg"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "45%"
  }
}, "Entry mode"), /*#__PURE__*/_createElementVNode("div", null, "********")]), /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex fl-jsb mb-10 freg"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "45%"
  }
}, "AID"), /*#__PURE__*/_createElementVNode("div", null, "****************")]), /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex fl-jsb mb-10 freg"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "45%"
  }
}, "MID"), /*#__PURE__*/_createElementVNode("div", null, "**")]), /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex fl-jsb mb-10 freg"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "45%"
  }
}, "TID"), /*#__PURE__*/_createElementVNode("div", null, "****************")]), /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex fl-jsb mb-20 freg"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "45%"
  }
}, "PTID"), /*#__PURE__*/_createElementVNode("div", null, "********")]), /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex fl-jsb mb-10 freg"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "45%"
  }
}, "Auth. code"), /*#__PURE__*/_createElementVNode("div", null, "******")]), /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex fl-jsb mb-10 freg"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "45%"
  }
}, "Tender"), /*#__PURE__*/_createElementVNode("div", null, "****************")]), /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex fl-jsb mb-20 freg highlight"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "45%"
  }
}, "Reference"), /*#__PURE__*/_createElementVNode("div", null, "NEW_POS_*****_**********_**********")]), /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex fl-jsb mb-10 freg"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "45%"
  }
}, "Type"), /*#__PURE__*/_createElementVNode("div", null, "GOODS_SERVICES")]), /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex fl-jsb mb-10 freg"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "45%"
  }
}, "Total"), /*#__PURE__*/_createElementVNode("div", null, "EUR 100.00")])])], -1);

var _hoisted_6 = {
  class: "d-flex flex-column fl-a-c fl-j-c"
};
var _hoisted_7 = {
  class: "mt-10",
  style: {
    "margin-bottom": "4rem"
  }
};
var _hoisted_8 = {
  key: 0,
  class: "d-flex fl-a-c fl-j-b mb-20",
  style: {
    "gap": "0.25rem"
  }
};
var _hoisted_9 = {
  key: 1,
  class: "mb-20"
};
var _hoisted_10 = {
  class: "d-flex fl-a-c fl-j-b mb-20",
  style: {
    "gap": "0.25rem"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_input = _resolveComponent("el-input");

  var _component_el_link = _resolveComponent("el-link");

  var _component_el_checkbox = _resolveComponent("el-checkbox");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
      return _ctx.dialogVisible = $event;
    }),
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "show-close": false,
    width: "700px"
  }, {
    default: _withCtx(function () {
      return [_ctx.showManualPaymentOption ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        class: "close-button",
        circle: "",
        onClick: _ctx.close
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_SvgIcon, {
            iconContent: _ctx.closeIcon,
            iconAlt: "close",
            iconStyle: "width: 20px; height: auto;",
            class: "close-icon"
          }, null, 8, ["iconContent"])];
        }),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        modelValue: _ctx.showManualPaymentModal,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return _ctx.showManualPaymentModal = $event;
        }),
        width: "600px",
        "custom-class": "manual-payment-modal"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString(_ctx.t("payment.complere-reference")), 1), _createElementVNode("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.referencePrefix), 1), _createVNode(_component_el_input, {
            modelValue: _ctx.userInput,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _ctx.userInput = $event;
            }),
            placeholder: "XXXXXXXXXX",
            style: {
              "width": "120px"
            },
            disabled: _ctx.noReceipt
          }, null, 8, ["modelValue", "disabled"])]), _createElementVNode("div", null, [_createVNode(_component_el_link, {
            type: "info",
            class: "mb-20",
            style: {
              "font-size": "13px"
            },
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return _ctx.showRecieptExampleModal = true;
            })
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("payment.highlight-reference")), 1)];
            }),
            _: 1
          })]), _createElementVNode("div", null, [_createVNode(_component_el_checkbox, {
            modelValue: _ctx.noReceipt,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return _ctx.noReceipt = $event;
            }),
            label: _ctx.$t('payment.no-receipt')
          }, null, 8, ["modelValue", "label"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
            size: "large",
            type: "success",
            onClick: _ctx.completePaymentManually,
            disabled: !_ctx.noReceipt && !_ctx.isMatchingReference
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("button.confirm")), 1)];
            }),
            _: 1
          }, 8, ["onClick", "disabled"])])]), _createVNode(_component_el_dialog, {
            modelValue: _ctx.showRecieptExampleModal,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
              return _ctx.showRecieptExampleModal = $event;
            }),
            width: "350px",
            "custom-class": "receipt-modal"
          }, {
            default: _withCtx(function () {
              return [_hoisted_5];
            }),
            _: 1
          }, 8, ["modelValue"])];
        }),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_6, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("payment.follow-instructions")), 1), _createElementVNode("div", _hoisted_7, [_createVNode(_component_SvgIcon, {
        iconContent: _ctx.iconContent,
        iconStyle: _ctx.iconStyle
      }, null, 8, ["iconContent", "iconStyle"])]), _ctx.showManualPaymentOption ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("payment.already-completed")), 1), _createVNode(_component_el_button, {
        type: "success",
        onClick: _cache[5] || (_cache[5] = function ($event) {
          return _ctx.toggleManualPaymentModal(true);
        }),
        link: "",
        style: {
          "text-decoration": "underline",
          "font-weight": "bolder"
        }
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("payment.complete-manually")), 1)];
        }),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t("payment.wait-for-completion")) + " ... (" + _toDisplayString(_ctx.timeLeft) + "s) ", 1)), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("payment.want-to-cancel")), 1), _createVNode(_component_el_button, {
        type: "danger",
        onClick: _ctx.abortPayment,
        link: "",
        style: {
          "text-decoration": "underline",
          "font-weight": "bolder"
        }
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("payment.cancel")), 1)];
        }),
        _: 1
      }, 8, ["onClick"])])])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}